/**
 * @generated SignedSource<<d6acb25b5616268faf003361eb8262ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonSidePanelNotes_person$data = {
  readonly email: string | null | undefined;
  readonly id: number;
  readonly is_placeholder: boolean;
  readonly people_notes: ReadonlyArray<{
    readonly created_at: any;
    readonly created_by: string | null | undefined;
    readonly creator_email: string | null | undefined;
    readonly id: number;
    readonly note: string;
    readonly updated_at: any;
    readonly user_id: number | null | undefined;
  }>;
  readonly " $fragmentType": "PersonSidePanelNotes_person";
};
export type PersonSidePanelNotes_person$key = {
  readonly " $data"?: PersonSidePanelNotes_person$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersonSidePanelNotes_person">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonSidePanelNotes_person",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "is_placeholder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "people_notes",
      "kind": "LinkedField",
      "name": "people_notes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "note",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created_at",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updated_at",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creator_email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created_by",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "user_id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "people",
  "abstractKey": null
};
})();

(node as any).hash = "7ee4747191e58ebe1b24209e09e28e7b";

export default node;
